import { PublicReview } from '@shared/types';
import { flattenMinisiteAndEmbedContext } from '../../hooks/useCourseVisibility';

export type GetEducatorReviewsResult = {
    reviews: PublicReview[];
    nextPageToken: string | null;
};

export const getEducatorReviews = async (
    educatorParam: string,
    appContext: 'minisite' | 'marketplace' | 'embed',
    pageToken?: string
): Promise<GetEducatorReviewsResult> => {
    const reviewContext = flattenMinisiteAndEmbedContext(appContext);
    const appContextQueryString = `?context=${reviewContext}`;
    const pageTokenQueryString = pageToken ? `&pageToken=${pageToken}` : '';
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/reviews/list/${educatorParam}${appContextQueryString}${pageTokenQueryString}`,
        {
            method: 'GET',
            credentials: 'include',
            cache: 'no-cache',
        }
    );

    if (response.status === 404 || response.status === 423) {
        const error = new Error('404 - Not found');
        throw error;
    }
    if (response.ok === false) {
        const error = await response.text();
        throw new Error(error);
    }
    const result = await response.json();
    if (!Array.isArray(result.reviews)) {
        const error = new Error('404 - Not found');
        throw error;
    }

    return {
        reviews: result.reviews,
        nextPageToken: result.nextPageToken || null,
    };
};
